import {Injectable} from '@angular/core';
import {HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {RandomSessionIdService} from "../../../guards/random-session-id.service";

@Injectable()
export class SessionIdInterceptor implements HttpInterceptor {
    private whitelist: string[] = [
        'https://cloud-functions-api-gw-config-926xrm2x.wl.gateway.dev/API-Homologacion-DOT',
    ];
    constructor(private randomSessionIdService: RandomSessionIdService) {
    }
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const shouldIgnore = this.whitelist.some(whitelistedUrl => req.url.includes(whitelistedUrl));
        if (shouldIgnore) {
            return next.handle(req);
        }
        const sessionId = this.randomSessionIdService.randomSessionId();
        const newRequest = req.clone({
            url: `${req.url}` + (req.urlWithParams.includes('?') ? '&sessionId=' + sessionId : '?sessionId=' + sessionId),
        });
        return next.handle(newRequest);
    }
}
